import { axios } from 'src/api'
import { ApiFetchRolesResponse } from './roles.types'

export const apiFetchRoles = async (userToken: string, serverPath: string) => {
  const response = await axios.post<ApiFetchRolesResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/role`,
    {
      userToken
    }
  )
  return response
}
